import {OrderSheetEntry, OrderSheetPageSet} from '@web/core/constants'

/** 타이틀 */
export const OrderTitle = '주문/결제'

export const PageSet = OrderSheetPageSet.EASYBOOKING

export const Entry = OrderSheetEntry.FLEA_MARKET

export type FulfilledException = {
    code: string
    fallbackMessage?: string
}
